// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"d4fa3fbf","703":"d2ab8eb4","787":"680156c1"}[chunkId] + ".chunk.js";
};